(function () {
    "use strict";

    angular.module("app").controller("DashboardController", DashboardController);

    DashboardController.$inject = ["$scope", "loadingIndicatorService", "enumService"];
    function DashboardController($scope, loadingIndicatorService, enumService) {

        loadingIndicatorService.SetLoadingState(false);

        $scope.GetDashBoardButton = (name) => {
            if (!name)
                return 0;
            if (!$scope.dashboardData)
                return "...";

            const found = $scope.dashboardData.find(x => x.ColDashBoardButton === enumService.ColDashboardNumberType[name]);

            return !found ? 0 : found.Amount;
        };

        function loadData(d) {
            $scope.dashboardData = d;
            $scope.$apply();
        }

        function getDashboardNumbers() {
            const connection = $.hubConnection();
            const dashboardHubProxy = connection.createHubProxy("dashboardTicker");
            dashboardHubProxy.on("updateDashboard", loadData);
            connection.start().done(() => dashboardHubProxy.invoke("getDashboard").done(loadData));
        }

        getDashboardNumbers();
    }
})();
